var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktopBrowsersGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 2.5h10.5c.82 0 1.5.68 1.5 1.5v6.75c0 .844-.68 1.5-1.5 1.5H9.125l.234.75H11c.398 0 .75.352.75.75 0 .422-.352.75-.75.75H5a.74.74 0 0 1-.75-.75c0-.398.328-.75.75-.75h1.617l.258-.75H2.75a1.48 1.48 0 0 1-1.5-1.5V4c0-.82.656-1.5 1.5-1.5zM13.25 4H2.75v5.25h10.5V4z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopBrowsersGrey);
export default __webpack_public_path__ + "static/media/desktop_browsers_grey.c54328bb396c244b92d6ea2ec7dfa2d8.svg";
export { ForwardRef as ReactComponent };